"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TwitchLiveVideo2Schema = void 0;
exports.TwitchLiveVideo2Schema = {
    "$id": "https://www.redbull.com/schemas/content/ext/services/twitch-livevideo/2.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "TwitchLiveVideo2",
    "description": "Embed a live video from Twitch",
    "type": "object",
    "properties": {
        "type": {
            "type": "string",
            "enum": [
                "rrn:content:ext:services:twitch-livevideo:2"
            ]
        },
        "attributes": {
            "type": "object",
            "oneOf": [
                {
                    "required": [
                        "channelName"
                    ]
                },
                {
                    "required": [
                        "clipId"
                    ]
                },
                {
                    "required": [
                        "videoId"
                    ]
                }
            ],
            "properties": {
                "channelName": {
                    "type": "string",
                    "description": "A twitch channel name (e.g. 'kraken')"
                },
                "clipId": {
                    "type": "string",
                    "description": "Twitch clip id (e.g. 'eleaguetv/ZealousMosquitoPeteZarollTie')"
                },
                "videoId": {
                    "type": "string",
                    "description": "Twitch video id (e.g. 'c6055863')"
                }
            }
        }
    },
    "required": [
        "type",
        "attributes"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiMi5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi8uLi9zcmMvbW9kdWxlcy9jb250ZW50L2V4dC9zZXJ2aWNlcy90d2l0Y2gtbGl2ZXZpZGVvLzIuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsc0JBQXNCLEdBQUc7SUFDcEMsS0FBSyxFQUFFLHFGQUFxRjtJQUM1RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxrQkFBa0I7SUFDM0IsYUFBYSxFQUFFLGdDQUFnQztJQUMvQyxNQUFNLEVBQUUsUUFBUTtJQUNoQixZQUFZLEVBQUU7UUFDWixNQUFNLEVBQUU7WUFDTixNQUFNLEVBQUUsUUFBUTtZQUNoQixNQUFNLEVBQUU7Z0JBQ04sNkNBQTZDO2FBQzlDO1NBQ0Y7UUFDRCxZQUFZLEVBQUU7WUFDWixNQUFNLEVBQUUsUUFBUTtZQUNoQixPQUFPLEVBQUU7Z0JBQ1A7b0JBQ0UsVUFBVSxFQUFFO3dCQUNWLGFBQWE7cUJBQ2Q7aUJBQ0Y7Z0JBQ0Q7b0JBQ0UsVUFBVSxFQUFFO3dCQUNWLFFBQVE7cUJBQ1Q7aUJBQ0Y7Z0JBQ0Q7b0JBQ0UsVUFBVSxFQUFFO3dCQUNWLFNBQVM7cUJBQ1Y7aUJBQ0Y7YUFDRjtZQUNELFlBQVksRUFBRTtnQkFDWixhQUFhLEVBQUU7b0JBQ2IsTUFBTSxFQUFFLFFBQVE7b0JBQ2hCLGFBQWEsRUFBRSx1Q0FBdUM7aUJBQ3ZEO2dCQUNELFFBQVEsRUFBRTtvQkFDUixNQUFNLEVBQUUsUUFBUTtvQkFDaEIsYUFBYSxFQUFFLGdFQUFnRTtpQkFDaEY7Z0JBQ0QsU0FBUyxFQUFFO29CQUNULE1BQU0sRUFBRSxRQUFRO29CQUNoQixhQUFhLEVBQUUsbUNBQW1DO2lCQUNuRDthQUNGO1NBQ0Y7S0FDRjtJQUNELFVBQVUsRUFBRTtRQUNWLE1BQU07UUFDTixZQUFZO0tBQ2I7Q0FDRixDQUFBIn0=